import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = {
  class: "company-listing-area pt-120 mb-120",
  id: "scrollTarget"
}
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row g-lg-4 gy-5" }
const _hoisted_9 = { class: "col-lg-4 order-lg-1 order-2" }
const _hoisted_10 = { class: "job-sidebar" }
const _hoisted_11 = { class: "job-widget style-1 mb-20" }
const _hoisted_12 = { class: "check-box-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "job-widget-title" }, "Company Category", -1)
const _hoisted_14 = { class: "checkbox-container" }
const _hoisted_15 = { class: "containerss" }
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "qty" }
const _hoisted_20 = { class: "job-widget mb-20" }
const _hoisted_21 = { class: "check-box-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h5", { class: "job-widget-title" }, "Country/ Location", -1)
const _hoisted_23 = { class: "checkbox-container" }
const _hoisted_24 = { class: "containerss" }
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_27 = { class: "text" }
const _hoisted_28 = { class: "qty" }
const _hoisted_29 = { class: "col-lg-8 order-lg-2 order-1" }
const _hoisted_30 = { class: "company-listing-wrap" }
const _hoisted_31 = { class: "row g-4 mb-25" }
const _hoisted_32 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_33 = { class: "show-item" }
const _hoisted_34 = { class: "row g-4 mb-70" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "company-list-card1" }
const _hoisted_37 = { class: "company-area" }
const _hoisted_38 = { class: "logo" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "company-content" }
const _hoisted_41 = { class: "company-details" }
const _hoisted_42 = { class: "name-location" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/location.svg",
  alt: ""
}, null, -1)
const _hoisted_44 = { class: "job-details-vacancies" }
const _hoisted_45 = { class: "vacancies" }
const _hoisted_46 = { class: "apply-btn" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/images/icon/apply-ellipse.svg",
    alt: ""
  })
], -1)
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-lg-12 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Company Listing", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyTypeFilters, (category) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: category.id
                        }, [
                          _createElementVNode("label", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: category.id,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.CompanyTypeFilter) = $event)),
                              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterJobs && _ctx.filterJobs(...args)))
                            }, null, 40, _hoisted_16), [
                              [_vModelCheckbox, _ctx.CompanyTypeFilter]
                            ]),
                            _hoisted_17,
                            _createElementVNode("span", _hoisted_18, _toDisplayString(category.name), 1),
                            _createElementVNode("span", _hoisted_19, "(" + _toDisplayString(category.counts) + ")", 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyLocationFilters, (category) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: category.id
                        }, [
                          _createElementVNode("label", _hoisted_24, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: category.id,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.CompanyLocationFilter) = $event)),
                              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterJobs && _ctx.filterJobs(...args)))
                            }, null, 40, _hoisted_25), [
                              [_vModelCheckbox, _ctx.CompanyLocationFilter]
                            ]),
                            _hoisted_26,
                            _createElementVNode("span", _hoisted_27, _toDisplayString(category.name), 1),
                            _createElementVNode("span", _hoisted_28, "(" + _toDisplayString(category.counts) + ")", 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("p", _hoisted_33, "Showing results 10 in " + _toDisplayString(_ctx.totalPages) + " jobs list", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createVNode(_component_ProgressSpinner)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.companies, (company) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: company.id,
                        class: "col-md-6"
                      }, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("img", {
                                src: (company.logo) ? company.logo : '/assets/images/work-pages-logo.png',
                                alt: ""
                              }, null, 8, _hoisted_39)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("h5", null, _toDisplayString(company.name), 1),
                                  _createElementVNode("p", null, [
                                    _hoisted_43,
                                    _createTextVNode(" " + _toDisplayString(company.location), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("p", null, [
                                    _createTextVNode("Vacancies: "),
                                    _createElementVNode("span", null, _toDisplayString(company.jobs_count), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createVNode(_component_router_link, {
                                    to: _ctx.getCompanyDetail(company.id)
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_47,
                                      _createTextVNode("View Details")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_Paginator, {
                    first: _ctx.currentPage,
                    "onUpdate:first": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentPage) = $event)),
                    rows: _ctx.rowsPerPage,
                    totalRecords: _ctx.totalPages,
                    onPage: _ctx.handlePageChange
                  }, null, 8, ["first", "rows", "totalRecords", "onPage"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}